import * as Api from './api';
import * as Service from './service';
import { SwitchContext, EngineContext as UseEngineContext, SchemaContext, AppContext } from './context/state';
import CacheService from './cache';
import DB from './db/database';
import PluginService from './plugin';

let EngineContext!: UseEngineContext;
let Switch!: SwitchContext;
let Cache!: CacheService;
let Plugin: PluginService;

function init() {
    EngineContext = new UseEngineContext();
    Switch = new SwitchContext();
    Cache = new CacheService();
    Plugin = new PluginService();
}

export { init, Api, Service, EngineContext, Switch, Cache, DB, Plugin };

export type { SchemaContext, AppContext };
